<button matTooltip="{{ label }}" mat-icon-button (click)="expanded = !expanded">
    <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
</button>
<div *ngIf="expanded" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="15px" [formGroup]="timeSpendForm">
    <app-user-setting-input
        type="number"
        [control]="timeSpendForm.get('hours') | cast"
        i18n-placeholder="@@plsEnterYourHours"
        placeholder="Pls enter your hours"
    >
        <label role="input-label">
            <span i18n="@@hours">Hours</span>
        </label>
    </app-user-setting-input>
    <app-user-setting-input
        type="number"
        [control]="timeSpendForm.get('minutes') | cast"
        i18n-placeholder="@@plsEnterYourMinutes"
        placeholder="Pls enter your minutes"
    >
        <label role="input-label">
            <span i18n="@@minutes">Minutes</span>
        </label>
    </app-user-setting-input>
</div>
